import { render } from "./DeleteSModal.vue?vue&type=template&id=eddf7490&scoped=true"
import script from "./DeleteSModal.vue?vue&type=script&lang=js"
export * from "./DeleteSModal.vue?vue&type=script&lang=js"

import "./DeleteSModal.vue?vue&type=style&index=0&id=eddf7490&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddf7490"]])

export default __exports__